import api from '../../api/restaurant/restaurantRawMaterialCategoryApi';
import {
  CustomResponse,
  RestaurantRawMaterialCategoryDTO,
  RestaurantRawMaterialCategoryFilters,
  RestaurantRawMaterialCategoryForm,
  RestaurantRawMaterialCategoryPage,
} from '../../types/restaurant/RestaurantRawMaterialCategoryTypes';
import { RestaurantPageRequest } from '../../types/restaurant/RestaurantRecipeTypes';
import { restaurantPageQuery } from './restaurantPageQuery';
const payload = (form: RestaurantRawMaterialCategoryForm) => ({
  name: form.name.trim(),
  description: form.description.trim() || null,
  icon: form.icon.trim() || null,
  color: form.color.trim() || null,
  displayOrder: Number(form.displayOrder),
  // El código lo genera el backend a partir del nombre y lo conserva al
  // editar; el formulario ya no lo envía.
  ...(form.id ? { active: form.active } : {}),
});
const RestaurantRawMaterialCategoryService = {
  listFiltered: async (
    branchId: number,
    request: RestaurantPageRequest<RestaurantRawMaterialCategoryFilters>
  ) => {
    const query = restaurantPageQuery(request.page, request.size, request.sort);
    return (
      await api.addCustom(`/branches/${branchId}/filtered?${query}`, {
        search: request.filters.search?.trim() || null,
        active: request.filters.active,
      })
    ).data as RestaurantRawMaterialCategoryPage;
  },
  list: async (branchId: number, activeOnly = false) =>
    (await api.fetchCustom(`/branches/${branchId}?activeOnly=${activeOnly}`))
      .data as CustomResponse<RestaurantRawMaterialCategoryDTO[]>,
  get: async (id: number) =>
    (await api.fetchById(id))
      .data as CustomResponse<RestaurantRawMaterialCategoryDTO>,
  create: async (branchId: number, form: RestaurantRawMaterialCategoryForm) =>
    (await api.addCustom(`/branches/${branchId}`, payload(form)))
      .data as CustomResponse<RestaurantRawMaterialCategoryDTO>,
  update: async (id: number, form: RestaurantRawMaterialCategoryForm) =>
    (await api.modify(id, payload(form)))
      .data as CustomResponse<RestaurantRawMaterialCategoryDTO>,
  updateActive: async (id: number, active: boolean) =>
    (await api.patchCustom(`${id}/active`, { active }))
      .data as CustomResponse<RestaurantRawMaterialCategoryDTO>,
};
export default RestaurantRawMaterialCategoryService;
